import { eq } from 'drizzle-orm'
import { db } from '@/db'
import { users } from '@/db/schema'

function authProviderFromAccount(provider?: string | null) {
  if (provider === 'google') return 'google'
  if (provider === 'nodemailer' || provider === 'email') return 'magic_link'
  return undefined
}

export async function recordUserLogin(userId: string, provider?: string | null, now = new Date()) {
  const authProvider = authProviderFromAccount(provider)

  await db
    .update(users)
    .set({
      ...(authProvider ? { authProvider } : {}),
      lastLoginAt: now,
      updatedAt: now,
    })
    .where(eq(users.id, userId))
}
